import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FormulaListEffects } from './formula-list.effects';
import { reducer } from './formula-list.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('formulaList', reducer),
    EffectsModule.forFeature([FormulaListEffects]),
  ],
  providers: [FormulaListEffects],
})
export class FormulaListStoreModule {}
